<p-sidebar [(visible)]="visible" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" styleClass="layout-profile-sidebar w-full sm:w-25rem">
    <div class="flex flex-column mx-auto md:mx-0">
        <span class="mb-2 font-semibold">{{lang.el('Benvenuta/o')}}</span>
        <span class="text-color-secondary font-medium mb-5">{{globalservice.fullName}}</span>

        <ul class="list-none m-0 p-0">
           
            <li>
                <a class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover 
                transition-colors transition-duration-150">
                    <span>
                        <i class="pi pi-cog text-xl text-primary"></i>
                    </span>
                    <div class="ml-3"  (click)="showProfilo=true;">
                        <span class="mb-2 font-semibold">{{lang.el('Profilo')}}</span>
                        <p class="text-color-secondary m-0">{{lang.el('Modifica i tuoi dati utente')}}</p>
                    </div>
                </a>
            </li>
           
            <li>
                <a class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">  
                    <div class="flex flex-wrap row-gap-3">
                        <span>
                            <i class="pi pi-cog text-xl text-primary"></i>
                        </span>
                        <div class="ml-3">
                            <div class="flex-wrap">
                                <span class="mb-2 font-semibold">{{lang.el('Dimensioni')}}</span>
                                <div class="flex">
                                    <button icon="pi pi-minus" type="button" pButton (click)="decrementScale()" class="p-button-text p-button-rounded w-2rem h-2rem mr-2" [disabled]="scale === scales[0]"></button>
                                    <div class="flex gap-2 align-items-center">
                                        <i class="pi pi-circle-fill text-300" *ngFor="let s of scales" [ngClass]="{'text-primary-500': s === scale}"></i>
                                    </div>
                                    <button icon="pi pi-plus"  type="button" pButton (click)="incrementScale()" class="p-button-text p-button-rounded w-2rem h-2rem ml-2" [disabled]="scale === scales[scales.length - 1]"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </li>
            <li>
                <a class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                    <span>
                        <i class="pi pi-power-off text-xl text-primary"></i>
                    </span>
                    <div class="ml-3" (click)="signout()">
                        <span  class="mb-2 font-semibold">{{lang.el('Esci')}}</span>
                        <p class="text-color-secondary m-0">{{lang.el('Termina sessione')}}</p>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</p-sidebar>

<p-dialog header="{{lang.el('Profilo utente')}}" [(visible)]="showProfilo" 
[modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <div class="grid">
        <div class="col-3 p-4" >
          <span style="font-size:500%;height: 150px;
          width: 150px;
          background-color: var(--primary-color);
          border-radius: 50%;
          color:#FFF;
          text-align: center;
          padding-top: 22px;
          display: inline-block;">{{globalservice.userInitials}}</span>
        </div>
        <div class="col-9">
            <div class="grid grid-nogutter flex-wrap gap-3 p-fluid">
                <div class="col-12 pl-2">
                    <p-tabView> 
                        <p-tabPanel header="{{lang.el('Profilo')}}" > 
                            <form [formGroup]="form">
                                <div class="formgrid">       
                                    <formly-form [model]="model" 
                                    [fields]="tabsFields" 
                                    [options]="options" 
                                    [form]="form"></formly-form>                     
                                </div>
                            </form>
                        </p-tabPanel>
                         <p-tabPanel header="{{lang.el('Password')}}" > 
                            <div class="grid p-fluid formgrid">
                                <div class="col-6">
                                     <label>{{lang.el('Password attuale')}}</label>
                                    <input type="text" pInputText [(ngModel)]="passwordAttuale" />
                                </div>
                                 <div class="col-6"></div>
                                <div class="col-6">
                                     <label>{{lang.el('Nuova password')}}</label>
                                    <input type="text" pInputText [(ngModel)]="password" />
                                </div>
                                <div class="col-6">
                                    <label>{{lang.el('Ripeti password')}}</label>
                                    <input type="text" pInputText [(ngModel)]="passwordRipeti" />
                                </div>
                            </div>
                         </p-tabPanel>
                    </p-tabView>
                </div>
            </div>
        </div>
   </div>
   
    
  <p-footer>
    <button pButton 
    [disabled]="!form.valid  && password==''"
    label="{{lang.el('Aggiorna profilo')}}" class="p-button-success p-button-text" (click)="saveProfilo()"></button>
  </p-footer>
</p-dialog>
<p-toast></p-toast>